import { memoWithDisplayName } from 'shared/utils/memoWithDisplayName';

import { AveragePriceSEOBlockContainer } from '../AveragePriceSEOBlock';
import { HeaderSEOBlockContainer } from '../HeaderSEOBlock';
import { QuickLinksContainer } from '../QuickLinks';
import { SEOBlockLayout } from '../SEOBlockLayout';

export const SEOBlock = memoWithDisplayName(
  () => (
    <SEOBlockLayout
      averagePrice={<AveragePriceSEOBlockContainer />}
      header={<HeaderSEOBlockContainer />}
      quickLinks={<QuickLinksContainer />}
    />
  ),
  'SEOBlock',
);
